import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UxService } from '~/app/core/services';
import { RoleService } from '../../core/services';
import { Project } from '../models/project.model';
import { GatewayApi } from './gateway.api';

@Injectable()
export class ProjectService extends GatewayApi<Project> {
  constructor(
    http: HttpClient,
    private auth: RoleService,
    uxService: UxService
  ) {
    super('projects', http, auth, uxService);
  }
}
